import React, { useState, useEffect } from 'react';
import { FaSave } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Auth } from 'aws-amplify';
import { useToasts } from 'react-toast-notifications';
import { Formik } from "formik";
import * as yup from "yup";
import { API } from 'aws-amplify';

import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import './Signup.css';

const Signup = (props) => {
	const { t } = useI18n();
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [contractorList, setContractorList] = useState([]);
	const [showpassword, setShowpassword] = useState(true);
	const [inputemail, setInputemail] = useState('');
	const [requiredpassword, setRequiredpassword] = useState(true);

    const { addToast } = useToasts();
    const params = { 
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,        
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
	}
	
	// Load contractors
	useEffect(()=>{
		const fetchContractors = async () => {
			
			const contractors = await API.get('settings','/CONTRACTORS', params)
			contractors.values.sort((a, b) => (a > b) ? 1 : -1)

			let list = []
			for (let i = 0; i < contractors.values.length; i++) {
				list.push(<option key={contractors.values[i]} value={contractors.values[i]}>{contractors.values[i]}</option>)
			}

			setContractorList(list);

		}
		fetchContractors();	 
	}, []);
	let headerglobal = {
		'x-api-key': process.env.REACT_APP_CITY_API_TOKEN,        
		'Accept': 'application/json',
		'Content-Type': 'application/json'
}

	useEffect(()=>{
		// API.get('user_update_access','?id=' + inputemail, { headers: headerglobal })
    //             .then(res => {
    //                 console.log(res, "res")
    //             }) 
    //             .catch((err) => {
    //                 console.log(err)
		// 						})
										
		let API_USER_ACCESS = process.env.REACT_APP_GLOBAL_API + '/user_app_access_get?id=' + inputemail;

    //             });
		fetch(API_USER_ACCESS, {
			method: 'GET',
			headers: headerglobal,
			})
			.then((response) => {
			if (!response.ok) throw Error(response.statusText);
			return response.json();
			})
			.then((responseJson) => {
				setShowpassword(false)
				setRequiredpassword(false)
				addToast(t('toast.userExists'), { appearance: 'success' });

			}).catch(e =>{
				setShowpassword(true)
				setRequiredpassword(true)
				console.log(e)
			})

	}, [inputemail]);

	const handleSubmit = async (data) => {

		try {
			if (data.web) data.web="true"; else data.web ="false";
      if (data.mobile) data.mobile="true"; else data.mobile ="false";
			if (data.reporting) data.reporting="true"; else data.reporting ="false";

			if(showpassword){
			await Auth.signUp({
				'username': data.email,
				'password': data.password,
				'attributes': {
					'name':data.name,
					'email':data.email,
					'custom:contractor': data.contractor,
					'custom:administrator': data.administrator,
					'custom:web': data.web,
					'custom:mobile': data.mobile,
					'custom:reporting': data.reporting,
				}
			});
			// addToast('User Saved', { appearance: 'success' });

			// Optionally mark the email as verified (admin action, via backend)
			if (data.emailVerified) {
				try {
					await API.get('user_verify_email', '/' + data.email, params);
				} catch (verifyErr) {
					console.log(verifyErr);
					addToast(t('toast.userCreatedUnverified'), { appearance: 'warning' });
				}
			}
		}
			// props.history.push('/users/');
			
		} catch (e) {			
			addToast(e.message, { appearance: 'error' });

		}

        let headerglobal = {
            'x-api-key': process.env.REACT_APP_CITY_API_TOKEN,        
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        let lsAppAccess = []
        if (data.mobile === 'true'){
				lsAppAccess.push("mobile")
				}
				if (data.reporting === 'true'){
						lsAppAccess.push("mobile-reporting")
				}
				if (data.web === 'true'){
						lsAppAccess.push("web")
				}

        let adminData
        
        if (data.administrator === "true") {
            adminData = 1
        }
        else {
            adminData = 0
        }

        API.put('user_access', `${process.env.REACT_APP_GLOB_APP_ENV}/` + data.email, {      
            body: {              
                [`${process.env.REACT_APP_GLOB_APP_ENV}`] : {
                "isAdmin": adminData,
                "app_access": lsAppAccess,
                "contractor": data.contractor,
                "accountStatus": "true"
                },
            },
            headers: headerglobal,
        })
        .then(res => {               
            addToast(t('toast.userSaved'), { appearance: 'success' });
            props.history.push('/users/');           
        }).catch(error => {
            console.log(error)
            addToast(t('toast.errorSavingUser') + ': ' + error, { appearance: 'error' });
        });  
        setBtnDisabled(true); 
	};


	const schema = yup.object().shape({
		name: yup.string()
			.required(t('common.required')),
		email: yup.string()
			.email(t('common.invalidEmail'))
			.required(t('common.required')),
		password: yup.string()
		.when("email", {
			is: (email) => {
				return requiredpassword;
			},
			then: yup.string()
				.min(8, t('common.passwordMin'))
				.matches(
					/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
					t('common.invalidPassword')
					)
				.required(t('common.required')),
		}),
			confirmPassword: yup.string()
			.when("email", {
				is: (email) => {
					return requiredpassword;
				},
				then: yup.string()
				.test('passwords-match', t('common.passwordMatch'), function(value) {
					if (!value) {
					return false;
					}
					return this.parent.password === value;
				})
				.required(t('common.required')),
			}),
		contractor: yup.string()
			.required(t('common.required')),
		administrator: yup.string()
			.required(t('common.required')),

		});

		  
	return (
		
		<Formik               
		initialValues={{name:'',
					  email:inputemail,
						password:'',
						contractor:'',
						confirmPassword:'',
						administrator:'false',
						web: false,
						mobile: false,
						reporting: false,
						emailVerified: false,
					 }}
		validationSchema={schema}
		onSubmit={ (values, { setSubmitting }) => {
			setBtnDisabled(true);
			handleSubmit(values);
			setSubmitting(false);
		}}

		>
		{({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
			
		<div className="Signup">
			<form key="frm1" onSubmit={handleSubmit}>
			<PageHeader
				title={t('pages.addUser.title')}
				breadcrumbs={[
					{ label: t('nav.users'), path: '/users' },
					{ label: t('pages.addUser.title') },
				]}
				backTo="/users"
				backLabel={t('nav.users')}
				subtitle={t('users.createSubtitle')}
				actions={
					<Button variant="success" type="submit" disabled={btnDisabled}>
						{t('actions.save')} <FaSave />
					</Button>
				}
			/>
			<div className="row div-content">
				<div className="col-md-6">
				<div className="pb-2">				
				<Form.Group controlId="name" className={touched.name && errors.name ? "has-error" : null}>
					<Form.Label>{t('fields.name')}</Form.Label>
					<Form.Control autoFocus 
					type="name" 
					value={values.name} 
					onChange={handleChange} 
					/>
					{touched.name && errors.name ? <div className="error-message">{errors.name}</div> : null} 
				</Form.Group>
				</div>
				<div className="pb-2">
				<Form.Group controlId="email" className={touched.email && errors.email ? "has-error" : null}>
					<Form.Label>{t('fields.email')}</Form.Label>
					<Form.Control 
					type="email" 
					value={values.email} 
					onChange={handleChange} />
					{setInputemail(values.email)}
					{touched.email && errors.email ? <div className="error-message">{errors.email}</div> : null} 
				</Form.Group>
				<Form.Check
					className="pt-2"
					type="checkbox"
					id="emailVerified"
					label={t('users.markVerified')}
					checked={values.emailVerified}
					onChange={handleChange}
				/>
				</div>
				<div className="pb-2">
				<Form.Group controlId="contractor" className={touched.contractor && errors.contractor ? "has-error" : null} >
					<Form.Label>{t('common.contractor')}</Form.Label>
					<Form.Control as="select" 
					value={values.contractor} 
					onChange={handleChange}>
						<option key="cont1" value=""></option>
						{contractorList}
					</Form.Control>
					{touched.contractor && errors.contractor ? <div className="error-message">{errors.contractor}</div> : null} 
				</Form.Group>
				</div>
				<div className="pb-2">
				<Form.Group controlId="administrator" className={touched.administrator && errors.administrator ? "has-error" : null}>
					<Form.Label>{t('fields.administrator')}</Form.Label>
					<Form.Control as="select" 
					value={values.administrator} 
					onChange={handleChange}>
						<option key="adm1" value="false">{t('users.no')}</option>
						<option key="adm2" value="true">{t('users.yes')}</option>						
					</Form.Control>
					{touched.administrator && errors.administrator ? <div className="error-message">{errors.administrator}</div> : null} 
				</Form.Group>				
				</div>	
				</div>
				<div className="col-md-6">
				{showpassword? 
					<div className="row p-0">
						<div className="col-md-6 p-0 pb-2">
						<Form.Group controlId="password" className={touched.password && errors.password ? "has-error" : null}>
						<Form.Label>{t('login.password')}</Form.Label>
							<Form.Control 
								value={values.password} 
								onChange={handleChange} 
								type="password" />						
						{touched.password && errors.password ? <div className="error-message">{errors.password}</div> : null} 
					</Form.Group>				
						<Form.Group controlId="confirmPassword" className={touched.confirmPassword && errors.confirmPassword ? "has-error" : null}>
							<Form.Label  className="pt-2">{t('fields.confirmPassword')}</Form.Label>
							<Form.Control 
							value={values.confirmPassword} 
							onChange={handleChange} 
							type="password" />
							{touched.confirmPassword && errors.confirmPassword ? <div className="error-message">{errors.confirmPassword}</div> : null} 
						</Form.Group>	
						</div>
						<div className="col-md-6">
							<div className="col-md-12 p-3 text-dark small bg-light border rounded">				
								<strong>{t('users.validPassword')}</strong>			
								<ul>
									<li>{t('users.pwdAtLeast')}</li>
									<li>{t('users.pwdCase')}</li>
									<li>{t('users.pwdNumber')}</li>
									<li>{t('users.pwdSpecial')} <strong>#?!@$%^&amp;*-</strong></li>
								</ul>	
							</div>			
						</div>
					</div>
					: <div></div>} 

					<div className="col-md-12 p-3 mt-4 bg-light border border-secondary rounded text-center">					
					<h4><strong>{t('fields.applicationAccess')}</strong></h4><br/>
					<Form.Check className="p-3" 
						inline 
						type="checkbox" 
						id="web" 
						label="Web" 
						onChange={handleChange} />
					<Form.Check className="p-3" 
						inline 
						type="checkbox" 
						id="mobile" 
						label="Mobile"
						onChange={handleChange} />
					<Form.Check className="p-3" 
						inline 
						type="checkbox" 
						id="reporting" 
						label="Mobile Reporting"
						onChange={handleChange} />
					</div>	
				</div>
		

			</div>
			</form>
		</div>
		)}
		</Formik> 
	);

}

export default Signup;